// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.specialoffers.RentalManagerUserPropertySpecialOfferWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingAlias, RentalManagerSpecialOfferInputsDto, UserPropertyDetailsSpecialOfferDto } from '../..';

interface DeleteParams {
  listingAlias: ListingAlias;
  offerIdEncoded: string;
}

export const RentalManagerUserPropertySpecialOfferWebApiHandler_create_Path =
  '/api/web/v1/users/properties/specialOffers/create';

/**
 * Create a special offer for a property
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_create = (
  postData: RentalManagerSpecialOfferInputsDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, RentalManagerSpecialOfferInputsDto, UserPropertyDetailsSpecialOfferDto>({
    endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_create_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/specialOffers/delete';

/**
 * Delete a listing special offer
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_delete = (
  getParams: DeleteParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<DeleteParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_delete_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySpecialOfferWebApiHandler_update_Path =
  '/api/web/v1/users/properties/specialOffers/update';

/**
 * Update a special offer of a property
 */
export const RentalManagerUserPropertySpecialOfferWebApiHandler_update = (
  postData: RentalManagerSpecialOfferInputsDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, RentalManagerSpecialOfferInputsDto, UserPropertyDetailsSpecialOfferDto>({
    endpoint: RentalManagerUserPropertySpecialOfferWebApiHandler_update_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
